import { mouseEventOk } from './mouseEventOk';

export function cleanupMouse(mouse, mol) {
  const orderedMouseKeys = ['lastMove', 'lastDown', 'lastUp'];

  let result = mouse;
  let ok = true;

  for (const key of orderedMouseKeys) {
    if (ok && result[key] != null && !mouseEventOk(result[key], mol)) {
      ok = false;
      result = { ...result };
    }

    if (!ok) {
      delete result[key];
    }
  }

  return result;
}
